// extracted by mini-css-extract-plugin
export default {"container":"CompanyForm_container__Udgyd","form":"CompanyForm_form__pE8tC","message":"CompanyForm_message__0d9K+"};